module.exports = __webpack_public_path__ + "img/pmi-salute-no-bg.f9cb7bab.png";